// extracted by mini-css-extract-plugin
export default {"videoOffOuter":"index-module__I5gVy","messageOuter":"index-module__OlRwj","inSidebar":"index-module__IgEi3"};